import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from "react-router-dom";
import {generateAPIPayload, links} from '../../helpers';


export default function FloatingNext(props) {
    let location = useLocation();
    const history = useHistory();
    const pageIndex = links.indexOf(location.pathname);
    const isLastPage = pageIndex == (links.length - 1);

    const handleNextPage = () => {
        if (pageIndex === links.length - 1) {
            return
        }
        history.push(links[pageIndex + 1]);
    }

    const handleSubmission = () => {
        //send the data to a processor to see if it is correct

        //if the data is good and we get something decent back

        //submit it to the API, dont reset the form yet
    }

    useEffect(() => {
        generateAPIPayload();
    }, [location.pathname])

    return (
        <div style={{
            position: "absolute",
            bottom: "10px",
            right: '10px',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#FEDD01',
            zIndex: 10,
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            boxShadow: '0 3px 5px #ccc'}}
            onClick={handleNextPage}
            >
                {
                    isLastPage && <CloudUploadIcon style={{width: '100%', fontSize: '2.5rem', cursor: 'pointer'}} />
                }
                {
                    !isLastPage && <ArrowForwardIcon style={{width: '100%', fontSize: '5rem', cursor: 'pointer'}} />
                }
        </div>
    )
}